import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 3.5H16.71C17.0959 2.61743 17.9751 2 19 2C20.3807 2 21.5 3.11929 21.5 4.5C21.5 5.88071 20.3807 7 19 7C17.9751 7 17.0959 6.38257 16.71 5.5H9V7H6.5V9.5H9V11H16.71C17.0959 10.1174 17.9751 9.5 19 9.5C20.3807 9.5 21.5 10.6193 21.5 12C21.5 13.3807 20.3807 14.5 19 14.5C17.9751 14.5 17.0959 13.8826 16.71 13H9V14.5H6.5V17H9V18.5H16.71C17.0959 17.6174 17.9751 17 19 17C20.3807 17 21.5 18.1193 21.5 19.5C21.5 20.8807 20.3807 22 19 22C17.9751 22 17.0959 21.3826 16.71 20.5H9V22H2V17H4.5V14.5H2V9.5H4.5V7H2V2H9V3.5Z"}}]};

const FlowchartFilled = Vue.extend<IconProps>({
  name: 'FlowchartFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flowchart-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FlowchartFilled;
